<ng-container *ngIf="hasMultipleEntries() && (shouldShowGroupTotal$ | async) && (groupTotal$ | async) as groupTotal">
  <div class="group-total">
    <div class="d-flex flex-column justify-content-end udex-py-20 udex-py-sm-32 udex-px-24">
      <p class="group-total__price  text-end heading__medium--xxxs udex-m-0">{{groupTotal}}</p>
      <p class="group-total__text body--xxs text-end udex-m-0 udex-mt-2">{{ 'checkout.groupTotal' | cxTranslate }}</p>
    </div>
    <udex-divider *ngIf="showDivider"></udex-divider>
  </div>
</ng-container>
